import React, { useEffect, useState } from "react";
import {
  TableCell,
  TableRow,
  MenuItem,
  FormControl,
  Select,
} from "@mui/material";
import { makeStyles } from "@material-ui/styles";
import SelectMenuItem from "../Customer/Component/SelectMenuItem";
import { useUpdateCustomerMutation } from "../../../Service/customers";
import { useDispatch, useSelector } from "react-redux";
import { GetcustomerList } from "../../../store/async-actions/digitalmarketing/dashboard";
import { useGetDashboardCustomersQuery } from "../../../Service/dashboard";
import { ServiceChosen } from "../Customer/Utils/CustomerLabelInput";
import edit from "../../../assets/DigitalMarketing/image/edit.svg";
import PermissionCheck from "../../../Component/PermissionCheck";
import noimage from "../../../assets/DigitalMarketing/image/no-image.jpg";
const useStyles = makeStyles({
  Mimo: {
    width: 123,
    "& .MuiSelect-select": {
      zIndex: "999",
      fontSize: "12px",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#FB6A6A",
      backgroundColor: "#FFF7F7",
      borderRadius: "6px",
    },
    "& .MuiSelect-icon": {
      zIndex: "999",
    },
  },
  Fertility: {
    width: 123,
    "& .MuiSelect-select": {
      zIndex: "999",
      fontSize: "12px",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#3BB54A",
      backgroundColor: "#F7FFF8",
      borderRadius: "6px",
    },
    "& .MuiSelect-icon": {
      zIndex: "999",
    },
  },
  Action: {
    width: 123,
    "& .MuiSelect-select": {
      zIndex: "999",
      fontSize: "12px",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#E6E6E6",
      borderRadius: "6px",
    },
    "& .MuiSelect-icon": {
      zIndex: "999",
    },
  },
  status: {
    width: 148,
    "& .MuiSelect-select": {
      zIndex: "999",
      fontSize: "12px",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
      borderRadius: "6px",
    },
    "& .MuiSelect-icon": {
      zIndex: "999",
    },
  },
});
interface props {
  customer_list: any;
  getComparator: any;
  order: any;
  orderBy: string;
  handleClick: any;
  handleChange: any;
  stableSort: any;
  onHandleEdit: any;
}
function TableList({
  customer_list,
  getComparator,
  order,
  orderBy,
  onHandleEdit,
  handleChange,
  stableSort,
}: props) {
  const classes = useStyles();
  const dispatch = useDispatch<any>();

  const DashboardStatus = useSelector((state: any) => state.dashboard.status);
  const [updateCustomer] = useUpdateCustomerMutation();
  let status = DashboardStatus.map((item) => ({
    label: item.name,
    value: item.id,
    icon: (
      <span
        style={{ backgroundColor: item.others }}
        className="blue me-2"
      ></span>
    ),
  }));

  const getValueByLabel = (label) => {
    let val = statuss.find((item) => item.label == label);
    if (val) {
      return val.value;
    }
    return 1;
  };
  const getLabelByValue = (value) => {
    let val = status.find((item) => item.value == value);
    if (val) {
      return val.label;
    }
    return "Created";
  };

  const handleSelectChange = (event, CustomerDetail) => {
    const { name, value } = event.target;
    if (CustomerDetail.customerId) {
      updateCustomer({
        id: CustomerDetail.customerId,
        customerStatus: getLabelByValue(value),
      });
      dispatch(GetcustomerList());
    }
  };

  const handleServiceChosenChange = (event, CustomerDetail) => {
    const { name, value } = event.target;
    if (CustomerDetail.customerId) {
      updateCustomer({
        id: CustomerDetail.customerId,
        serviceChoosen: value,
      });
      dispatch(GetcustomerList());
    }
  };
  let statuss = [
    {
      label: "Active",
      value: 1,
      icon: (
        <span style={{ backgroundColor: "green" }} className="blue me-2"></span>
      ),
    },
    {
      label: "Inactive",
      value: 2,
      icon: (
        <span style={{ backgroundColor: "red" }} className="blue me-2"></span>
      ),
    },
  ];

  return (
    <>
      {customer_list?.map((a, i) => {
        return (
          <TableRow
            hover
            className="cursur"
            role="checkbox"
            tabIndex={-1}
            key={i}
          >
            <TableCell align="left">{a.tipsTitle}</TableCell>
            <TableCell align="left">{a.tipsDescription}</TableCell>
            <TableCell align="left">
              <div className="rounded">
                <img src={a.wellnessImage!==null?a.wellnessImage:noimage} className="rounded-circle" />
              </div>
            </TableCell>
            <TableCell align="left">
              <p>{a.categoryName}</p>
            </TableCell>
            <TableCell align="left">
              <span>{a.scheduleDate}</span>
              {/* <br></br>
              <small>{a.time}</small> */}
            </TableCell>
            <TableCell align="left">
                <img
                  src={edit}
                  className="blue-c action-icon cursur me-2"
                  onClick={() => onHandleEdit(a)}
                />
            </TableCell>
          </TableRow>
        );
      })}
    </>
  );
}
export default React.memo(TableList);
